const Search = () => {
   return (
      <svg width="16" height="16" viewBox="0 0 16 16">
         <path fill="#8993A4" fillRule="evenodd"
            d="M6.8 13.6a6.8 6.8 0 115.34-2.59l3.626 3.624a.8.8 0 01-1.132 1.132L11.01 12.14A6.77 6.77 0 016.8 13.6zm3.728-3.175a.817.817 0 00-.103.103 5.2 5.2 0 11.102-.102z"
            clipRule="evenodd"></path>
      </svg >
   )
}
export default Search;